import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "opModalClickBlocker" }, null, -1)
const _hoisted_2 = { class: "opModal" }
const _hoisted_3 = { class: "modalHeader" }
const _hoisted_4 = { class: "modalBody" }
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = {
  key: 0,
  class: "modalFooter text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_select_and_buy_offers = _resolveComponent("select-and-buy-offers")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Prenota il tuo appuntamento!",
            text: "Prenota il tuo appuntamento!"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.cardPaid && !_ctx.bonificoPaid && _ctx.offers.length > 0)
          ? (_openBlock(), _createBlock(_component_select_and_buy_offers, {
              key: 0,
              offers: _ctx.offers,
              onCardpaid: _ctx.onCardPaid,
              onBonificopaid: _ctx.onBonificoPaid
            }, null, 8, ["offers", "onCardpaid", "onBonificopaid"]))
          : _createCommentVNode("", true),
        (_ctx.cardPaid || _ctx.bonificoPaid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.cardPaid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Il pagamento è andato a buon fine! Ora puoi prenotare presso il centro antifumo più vicino a te!",
                      text: "Il pagamento è andato a buon fine! Ora puoi prenotare presso il centro antifumo più vicino a te!"
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.callNext && _ctx.callNext(...args)))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Prenota!",
                          text: "Prenota!"
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bonificoPaid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Abbiamo inviato una mail con le coordinate per effettuare il bonifico.",
                      text: "Abbiamo inviato una mail con le coordinate per effettuare il bonifico."
                    }),
                    _hoisted_9,
                    _createVNode(_component_localized_text, {
                      localizedKey: "Segui le istruzioni per poter procedere con la tua prenotazione!",
                      text: "Segui le istruzioni per poter procedere con la tua prenotazione!"
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Chiudi",
                          text: "Chiudi"
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.cardPaid && !_ctx.bonificoPaid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Chiudi",
                text: "Chiudi"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}